import React from 'react';
import { LinkStyled, Space } from '@gr-monorepo/common/ui';
import { landingFunctionalLiteracyUrl, diagnosticUrl, safeInternetUrl } from './constants';

export const getTextMessageTwoModal = (utm: string) => {
  return `Здравствуйте! На платформе Учи.ру проходит соревнование «Академия функциональной грамотности» для педагогов и учеников 1–9 классов. Подробная информация: ${landingFunctionalLiteracyUrl + utm} \n \nДо 28 декабря включительно можно присоединиться к четвертому этапу. Он посвящен повышению функциональной и интернет-грамотности. Учителям необходимо: \n \n1. Открыть сервис «Мои задания» и выбрать раздел «Функциональная грамотность», затем выдать ученикам интерактивные карточки или тестовые упражнения: ${diagnosticUrl + utm}\n2. Организовать прохождение школьниками олимпиады «Безопасный интернет»: ${safeInternetUrl + utm} \n3.3. Убедиться, что минимум 15 учащихся или весь класс, если их меньше, выполнили задания. \n \nВ декабре это последняя возможность для учителей получить награды «Академии функциональной грамотности».`;
};

export const ContentTwoModal = ({ utm }: { utm: string }) => {
  return (
    <div style={{ fontSize: '16px', lineHeight: '22.4px' }}>
      <p>
        Просим передать педагогам информацию о новом блоке с заданиями по функциональной грамотности на платформе и сообщить, что соревнование скоро закончится — нужно успеть принять в нем участие.
      </p>
      <Space size={24} axis="vertical" />
      <div style={{ background: 'rgba(9, 21, 38, 0.07)', padding: '24px' }}>
        <p>
          Здравствуйте! На платформе Учи.ру проходит соревнование «Академия функциональной грамотности» для педагогов и учеников 1–9 классов. Подробная информация:
          <LinkStyled style={{ color: '#7F39FB' }} href={landingFunctionalLiteracyUrl + utm} target="_blank">
            {' '}
            https://distant.uchi.ru/functionalliteracy
          </LinkStyled>
        </p>
        <Space size={24} axis="vertical" />
        <p>
          <div>До 28 декабря включительно можно присоединиться к четвертому этапу. Он посвящен повышению функциональной и интернет-грамотности. Учителям необходимо:</div>
          <Space size={24} axis="vertical" />
          <div>
            1. Открыть сервис «Мои задания» и выбрать раздел «Функциональная грамотность», затем выдать ученикам интерактивные карточки или тестовые упражнения:
            <LinkStyled style={{ color: '#7F39FB' }} href={diagnosticUrl + utm} target="_blank">
              {' '}
              https://uchi.ru/lp/funcgram
            </LinkStyled>
          </div>
          <div>
            2. Организовать прохождение школьниками олимпиады «Безопасный интернет»: {' '}
            <LinkStyled style={{ color: '#7F39FB' }} href={safeInternetUrl + utm} target="_blank">
              {' '}
              https://safenet.uchi.ru
            </LinkStyled>
          </div>
          <div>
            3. Убедиться, что минимум 15 учащихся или весь класс, если их меньше, выполнили задания.
          </div>
        </p>
        <Space size={24} axis="vertical" />
        <p>В декабре это последняя возможность для учителей получить награды «Академии функциональной грамотности».</p>
      </div>
    </div>
  );
};
